import React from 'react';
import PropTypes from 'prop-types';
import ContentEditable from 'react-contenteditable';
import TextareaAutosize from 'react-autosize-textarea';
import './ContentEditableComponent.scss';
function Title(_ref) {
  var title = _ref.title,
    showError = _ref.showError,
    requiredText = _ref.requiredText;
  return /*#__PURE__*/React.createElement("div", {
    className: "editable-header ".concat(requiredText && 'add-spacing')
  }, title && /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("span", {
    className: "header-required".concat(showError ? ' with-error' : '')
  }, requiredText || '*'));
}
Title.propTypes = {
  title: PropTypes.string,
  requiredText: PropTypes.string,
  showError: PropTypes.bool
};
Title.defaultProps = {
  title: null,
  showError: null,
  requiredText: null
};
function Description(_ref2) {
  var description = _ref2.description;
  return description && /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, description);
}

// ContentEditableComponent ContentEditor
function ContentEditor(_ref3) {
  var value = _ref3.value,
    handleOnChange = _ref3.handleOnChange,
    className = _ref3.className,
    withBulletPoints = _ref3.withBulletPoints,
    showError = _ref3.showError,
    placeholder = _ref3.placeholder,
    required = _ref3.required,
    rehireOrProposalRequest = _ref3.rehireOrProposalRequest;
  if (withBulletPoints) {
    return /*#__PURE__*/React.createElement(ContentEditable, {
      html: value,
      disabled: false,
      onChange: function onChange(event) {
        return handleOnChange(event);
      },
      tagName: "ul",
      className: "".concat(className, " with-bullet-points ").concat(showError && !rehireOrProposalRequest && 'with-error')
    });
  }
  return /*#__PURE__*/React.createElement(TextareaAutosize, {
    className: "".concat(className, " textarea ").concat(showError && 'with-error'),
    placeholder: placeholder,
    value: value,
    required: required,
    onChange: function onChange(event) {
      return handleOnChange(event.target.value);
    }
  });
}
ContentEditor.propTypes = {
  withBulletPoints: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.string,
  handleOnChange: PropTypes.func,
  showError: PropTypes.bool,
  rehireOrProposalRequest: PropTypes.bool
};
ContentEditor.defaultProps = {
  withBulletPoints: false,
  required: false,
  placeholder: null,
  className: '',
  showError: null,
  value: '',
  handleOnChange: function handleOnChange() {},
  rehireOrProposalRequest: false
};

// ContentEditableComponent Footer
function Footer(_ref4) {
  var errorMessage = _ref4.errorMessage,
    showClearSuggestion = _ref4.showClearSuggestion,
    handleClearSuggestions = _ref4.handleClearSuggestions,
    suggestionText = _ref4.suggestionText;
  return /*#__PURE__*/React.createElement("div", {
    className: "footer"
  }, errorMessage && /*#__PURE__*/React.createElement("span", {
    className: "error"
  }, errorMessage), /*#__PURE__*/React.createElement("div", null, showClearSuggestion && suggestionText && /*#__PURE__*/React.createElement("span", {
    className: "suggestion-text"
  }, suggestionText), showClearSuggestion && /*#__PURE__*/React.createElement("a", {
    role: "button",
    tabIndex: 0,
    onClick: handleClearSuggestions
  }, "Clear Suggestions")));
}
Footer.propTypes = {
  errorMessage: PropTypes.string,
  handleClearSuggestions: PropTypes.func,
  showClearSuggestion: PropTypes.bool,
  suggestionText: PropTypes.string
};
Footer.defaultProps = {
  errorMessage: null,
  handleClearSuggestions: function handleClearSuggestions() {},
  showClearSuggestion: false,
  suggestionText: null
};
function ContentEditableComponent(_ref5) {
  var title = _ref5.title,
    description = _ref5.description,
    withBulletPoints = _ref5.withBulletPoints,
    placeholder = _ref5.placeholder,
    required = _ref5.required,
    showError = _ref5.showError,
    handleOnChange = _ref5.handleOnChange,
    value = _ref5.value,
    handleClearSuggestions = _ref5.handleClearSuggestions,
    showClearSuggestion = _ref5.showClearSuggestion,
    className = _ref5.className,
    errorMessage = _ref5.errorMessage,
    requiredText = _ref5.requiredText,
    rehireOrProposalRequest = _ref5.rehireOrProposalRequest,
    suggestionText = _ref5.suggestionText;
  return /*#__PURE__*/React.createElement("div", {
    className: "editable-container"
  }, /*#__PURE__*/React.createElement(Title, {
    title: title,
    showError: showError,
    requiredText: requiredText
  }), /*#__PURE__*/React.createElement(Description, {
    description: description
  }), /*#__PURE__*/React.createElement(ContentEditor, {
    value: value,
    handleOnChange: handleOnChange,
    className: className,
    withBulletPoints: withBulletPoints,
    placeholder: placeholder,
    showError: showError,
    required: required,
    rehireOrProposalRequest: rehireOrProposalRequest
  }), /*#__PURE__*/React.createElement(Footer, {
    errorMessage: errorMessage,
    showClearSuggestion: showClearSuggestion,
    handleClearSuggestions: handleClearSuggestions,
    suggestionText: suggestionText
  }));
}
ContentEditableComponent.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  withBulletPoints: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.string,
  errorMessage: PropTypes.string,
  handleOnChange: PropTypes.func,
  handleClearSuggestions: PropTypes.func,
  showClearSuggestion: PropTypes.bool,
  requiredText: PropTypes.string,
  showError: PropTypes.bool,
  rehireOrProposalRequest: PropTypes.bool,
  suggestionText: PropTypes.string
};
ContentEditableComponent.defaultProps = {
  title: null,
  description: null,
  withBulletPoints: false,
  required: false,
  placeholder: null,
  className: '',
  showError: null,
  errorMessage: null,
  value: '',
  handleOnChange: function handleOnChange() {},
  handleClearSuggestions: function handleClearSuggestions() {},
  showClearSuggestion: false,
  requiredText: null,
  rehireOrProposalRequest: false,
  suggestionText: null
};
export default ContentEditableComponent;